import route from '../../vendor/tightenco/ziggy/dist';
import { Ziggy } from "./routes";

export default (name, params, absolute) => route(name, params, absolute, Ziggy);
